import { Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarPaquete } from '../../../actions/configuracion';

const EliminarPaqueteModal = ({ show, paquete, onHide, onSuccess }) => {
    const dispatch = useDispatch();

    const onEliminar = async () => {
        const id = paquete?._id || '';
        if (!id) return;

        const ok = await dispatch(eliminarPaquete(id));
        if (!ok) return;

        if (typeof onSuccess === 'function') {
            await onSuccess();
        } else if (typeof onHide === 'function') {
            onHide();
        }
    };

    return (
        <Fragment>
            <Modal show={show} onHide={onHide} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Eliminar paquete</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="alert alert-warning mb-0">
                        ¿Seguro que deseas eliminar el paquete <b>{paquete?.nombre || ''}</b>?
                        <br />
                        Esta acción no se puede deshacer.
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={onHide}>
                        Cancelar
                    </button>

                    <button type="button" className="btn btn-danger" onClick={onEliminar}>
                        Eliminar
                    </button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default EliminarPaqueteModal;
